var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditStickers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "5 4 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.89,15.33a.61.61,0,0,0-.74.43,10.55,10.55,0,0,1-.59,1.66.6.6,0,0,0,.3.8.53.53,0,0,0,.35.05.6.6,0,0,0,.45-.34,11.48,11.48,0,0,0,.67-1.86.61.61,0,0,0-.44-.74",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -665,
    y: -440,
    width: 772,
    height: 1030,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.94,22.52a10.37,10.37,0,0,1-1.73.34.61.61,0,0,0,0,1.21h.15a11.56,11.56,0,0,0,1.93-.38.62.62,0,0,0,.41-.76.61.61,0,0,0-.75-.41",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.64,20a10.37,10.37,0,0,1-1.23,1.25.61.61,0,0,0-.07.86.6.6,0,0,0,.86.06,11.42,11.42,0,0,0,1.38-1.4.61.61,0,0,0-.94-.77",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.33,10.49a1.14,1.14,0,0,0,.41.07A1.31,1.31,0,0,0,12,9.67a1.33,1.33,0,0,0-.07-1A1.32,1.32,0,0,0,11.15,8,1.14,1.14,0,0,0,10.74,8a1.31,1.31,0,0,0-1.24.89,1.29,1.29,0,0,0,.83,1.65",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.68,11.6a1.14,1.14,0,0,0,.41.07,1.3,1.3,0,0,0,.41-2.54,1.14,1.14,0,0,0-.41-.07,1.31,1.31,0,0,0-1.24.89,1.3,1.3,0,0,0,.83,1.65",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.43,
    y: 0.94,
    width: 22.98,
    height: 22.75,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(4.57 4.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.41,12.61a1.6,1.6,0,0,0,0-.23A11.48,11.48,0,1,0,9.23,23.57l.17.07a1.12,1.12,0,0,0,.31.05,1.09,1.09,0,0,0,.67-.23L23,13.49a1.08,1.08,0,0,0,.41-.88M8.49,21.94A10.12,10.12,0,1,1,22,11.27,7.23,7.23,0,0,0,20,10.82a8.37,8.37,0,1,0-11.54,9,8.5,8.5,0,0,0,0,2.09m.29-3.44a7,7,0,1,1,9.88-7.7,11.1,11.1,0,0,0-5.76,2.26L7.84,11.4a3.44,3.44,0,0,0,2,4.8,8.67,8.67,0,0,0-1.06,2.3M22,12.89,10,22.4a.6.6,0,0,0-.22-.09l-.13,0a6.88,6.88,0,0,1-.08-2.06l0-.3v0a2.34,2.34,0,0,1,0-.26s0-.07,0-.11a1.16,1.16,0,0,1,0-.18,1.29,1.29,0,0,1,0-.19l0-.11a8.09,8.09,0,0,1,1.14-2.48A10.86,10.86,0,0,1,13.43,14l.76-.51h0a9.29,9.29,0,0,1,5-1.64,6.41,6.41,0,0,1,2.81.62c0,.11,0,.22,0,.32a.31.31,0,0,0,0,.1",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.07,
    y: 14.37,
    width: 11.84,
    height: 12.97
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.24,
    y: 21.56,
    width: 13.04,
    height: 11.58
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.76,
    y: 18.87,
    width: 12.52,
    height: 12.54
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-7)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7.01,
    width: 12.61,
    height: 12.61
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-9)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 8.12,
    width: 12.61,
    height: 12.61
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-11)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-13)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-14)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-13)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 32.98,
    height: 32.75
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditStickers);
export default __webpack_public_path__ + "static/media/edit-stickers.a4d54d363c90281e46ff4d2859225579.svg";
export { ForwardRef as ReactComponent };